import { UsaStates } from "usa-states";

import { inputs } from "../../../../inputs/inputConfigs";

const states = new UsaStates({ includeTerritories: true }).states;

const fields = ({ vendorContactStatusInput }) => ({
  groups: [
    {
      items: [
        {
          input: {
            ...inputs.firstName,
            name: "contact.person.firstName",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.lastName,
            name: "contact.person.lastName",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.phone,
            label: "Phone Number",
            name: "contact.person.phoneNumber",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.fax,
            label: "Fax",
            name: "contact.person.faxNumber",
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.fax,
            label: "Cell Number",
            name: "contact.person.cellNumber",
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.fax,
            label: "Work Number",
            name: "contact.person.workNumber",
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.contactRole,
            name: "contact.jobTitle",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            ...inputs.email,
            name: "contact.person.email",
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: vendorContactStatusInput,
          grid: { xs: 6 },
        },
      ],
    },
  ],
});

function remapOption(option, replacers) {
  const nOption = {
    ...option,
  };
  Object.keys(replacers).forEach(term => {
    nOption.name = nOption.name.replace(`[${term}]`, replacers[term]);
  });
  return nOption;
}

export function getVendorStatusOptions(vendor) {
  const vendorState = states.find(
    state => state.abbreviation === vendor.location.stateCode
  );
  const replacers = { State: vendorState ? vendorState.name : "Local" };
  return inputs.vendorContactStatus.options.map(option =>
    remapOption(option, replacers)
  );
}

export default vendor => {
  const vendorContactStatusInput = {
    ...inputs.vendorContactStatus,
    options: getVendorStatusOptions(vendor),
  };

  return fields({ vendorContactStatusInput });
};
